import { cx } from "@/utils/cx";
import type { ReactNode } from "react";

/**
 * The totals block (spec totals-row 1.0; sheet DS28).
 *
 * Line, then any discount, then the one total at weight 600 with its amount at 20 tabular. The
 * total is separated by the strong rule the spec gives it and it never highlights itself: no
 * orange, no tint, no hover tone. There is no VAT row: the checkout and invoice payloads do not
 * carry the workspace's tax status, and a "VAT 0.00" line invented to fill the shape would be a
 * statement about somebody's tax position that nothing in the data supports.
 */

export function TotalsLine({
  label,
  amount,
  className,
}: {
  label: ReactNode;
  amount: string;
  className?: string;
}) {
  return (
    <div
      className={cx(
        "gap-gk-4 flex min-h-[40px] items-center justify-between text-[14px]",
        className,
      )}
    >
      <span className="min-w-0 text-[var(--gk-text-secondary)]">{label}</span>
      <span className="gk-num flex-none text-[var(--gk-text-primary)]">
        {amount}
      </span>
    </div>
  );
}

export function TotalsTotal({
  label,
  amount,
}: {
  label: ReactNode;
  amount: string;
}) {
  return (
    <div className="gap-gk-4 ds-line-strong mt-gk-2 pt-gk-3 flex items-center justify-between border-t-2">
      <span className="text-[15px] font-semibold text-[var(--gk-text-primary)]">
        {label}
      </span>
      <span className="gk-num flex-none text-[20px] font-semibold text-[var(--gk-text-primary)]">
        {amount}
      </span>
    </div>
  );
}
